import { AppState } from "features/state";

export const getEditModifier = ({ modifiers: { edit } }: AppState) => {
    return edit.status === "loaded" ? edit.data : null;
};
